import { render, staticRenderFns } from "./SingularityPane.vue?vue&type=template&id=49e4cbd0&scoped=true&"
import script from "./SingularityPane.vue?vue&type=script&lang=js&"
export * from "./SingularityPane.vue?vue&type=script&lang=js&"
import style0 from "./SingularityPane.vue?vue&type=style&index=0&id=49e4cbd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e4cbd0",
  null
  
)

export default component.exports